import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@/shared/components/ProtectedRoute';
import { AppLayout } from '@/shared/components/Layout/AppLayout';
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { UserManagementPage } from '@/pages/UserManagementPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { SiteManagementPage } from '@/pages/SiteManagementPage';
import { ArchivedDataPage } from '@/pages/ArchivedDataPage';
import { IS_STG_DUMMY_SENDER_ENABLED } from '@/features/stg-dummy-sender/config/featureFlag';

// STG専用ダミーデータ送信機能はビルドフラグが有効な場合のみ有効化する。
// フラグが無効なビルド（本番）では、この分岐が静的にnullへ畳み込まれ、
// import()参照ごと除去されるためバンドルに含まれない（構造的除外）。
const StgDummySenderPage = IS_STG_DUMMY_SENDER_ENABLED
  ? React.lazy(() =>
      import('@/pages/DummySenderPage').then((module) => ({ default: module.DummySenderPage })),
    )
  : null;

export const AppRouter: React.FC = () => {
  return (
    <Routes>
      {/* ログインページ */}
      <Route path="/login" element={<LoginPage />} />

      {/* 認証が必要なルート */}
      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/users" element={<UserManagementPage />} />
          <Route path="/sites" element={<SiteManagementPage />} />
          <Route path="/archived-data" element={<ArchivedDataPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          {StgDummySenderPage && (
            <Route
              path="/stg-dummy-sender"
              element={
                <React.Suspense fallback={null}>
                  <StgDummySenderPage />
                </React.Suspense>
              }
            />
          )}
        </Route>
      </Route>

      {/* デフォルトリダイレクト */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />

      {/* 404ページ */}
      <Route path="*" element={<div>ページが見つかりません</div>} />
    </Routes>
  );
};
